import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getAddressAutocomplete } from '../api-ts';

/**
 * @param {String} partialAddress
 * @param {import('react-query').UseQueryOptions} useQueryOptions
 * @returns {import('react-query').UseQueryResult}
 */
export default function useGetAddressAutocomplete(partialAddress, useQueryOptions = {}) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['addressAutocomplete', partialAddress],
    queryFn: () => dispatch(getAddressAutocomplete({ partialAddress })),
    ...useQueryOptions,
    staleTime: 5 * 60 * 1000,
  });
}
